const features = [
  {
    title: "Sales Data Capture",
    desc: "Easily capture sales data in the field with real-time syncing to the web portal.",
    icon: "/images/dukaree/SalesDataCapture.jpg.avif",
  },
  {
    title: "Stock Management",
    desc: "Manage and track stock levels to ensure you never run out of inventory.",
    icon: "/images/dukaree/StockManagement.png",
  },
  {
    title: "Analytics & Reporting",
    desc: "Access custom analytics to forecast sales and optimize distribution strategies.",
    icon: "/images/dukaree/AnalyticsReporting.svg",
  },
  {
    title: "Field Sales Monitoring",
    desc: "Monitor and evaluate the activities of your sales teams on the go.",
    icon: "/images/dukaree/FieldSalesMonitoring.jpg.avif",
  },
  {
    title: "Automated Reporting",
    desc: "Generate automated reports to reduce manual data entry and improve decision-making.",
    icon: "/images/dukaree/AutomatedReporting.webp",
  },
  {
    title: "Customer Order Management",
    desc: "Understand and manage customer orders for better service delivery.",
    icon: "/images/dukaree/CustomerOrderManagement.jpg.avif",
  },
];

export function DukareeFeatures() {
  return (
    <div className="py-12">
      <h2 className="text-3xl font-bold text-center mb-12">
        Sales & Distribution Features
      </h2>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {features.map((feature, i) => (
          <div
            key={i}
            className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          >
            <div
              className="h-48 bg-cover bg-center"
              style={{ backgroundImage: `url(${feature.icon})` }}
            ></div>
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-600">{feature.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
